import React from 'react';
import { ADMIN_ACCESS } from './PermissionsRoutes';

const Manual = React.lazy(() => import('pages/help/Manual'))
const Inquiry = React.lazy(() => import('pages/help/Inquiry'))
const RemoteSupport = React.lazy(() => import('pages/help/RemoteSupport'))
const Faq = React.lazy(() => import('pages/common/Faq'))
const Reference = React.lazy(() => import('pages/help/Reference'))

const PF = '/help'
const RoutesHelp = [
    { path: `${PF}/manual`, exact: true, name: '사용설명서(도움말)', element: <Manual />, ...ADMIN_ACCESS },
    { path: `${PF}/inquiry`, exact: true, name: '1:1문의', element: <Inquiry />, ...ADMIN_ACCESS },
    { path: `${PF}/remote-support`, exact: true, name: '원격지원', element: <RemoteSupport />, ...ADMIN_ACCESS },
    { path: `${PF}/faq`, exact: true, name: '자주 묻는 질문', element: <Faq />, ...ADMIN_ACCESS },
    { path: `${PF}/reference`, exact: true, name: '참고 사항', element: <Reference />, ...ADMIN_ACCESS },
]

export default RoutesHelp;
